import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import Switch from '../../Shared/Controls/Switch'
import { filterReducer } from './eventFilters'
import useCustomTranslation from 'hooks/useCustomTranslation'
import InfoBox from 'components/Shared/InfoBox'

export function PastEventsFilter({ state, dispatch, submit, className }) {
  const [active, setActive] = useState(state.includePastEvents)
  const { getTranslation } = useCustomTranslation()
  useEffect(() => {
    setActive(state.includePastEvents)
  }, [state])

  return (
    <div className={`past-events-filter d-flex ${className ? className : ''}`}>
      <InfoBox
        title={getTranslation('Events.searchFilters.pastEventsSwitcher.title')}
        body={getTranslation('Events.searchFilters.pastEventsSwitcher.body')}
        classNames="past-events-filter_info-box"
      >
        <p className="d-inline-block switch_label mb-0">{getTranslation('Events.searchFilters.pastEvents')}</p>
      </InfoBox>

      <Switch
        classNames="past-events-filter_switch"
        checked={active}
        onClick={() => {
          const newStatus = !active
          setActive(newStatus)
          const action = { type: 'PAST_EVENTS', payload: newStatus }
          const newFilters = filterReducer(state, action)
          dispatch(action)
          submit(newFilters)
        }}
      />
    </div>
  )
}

PastEventsFilter.propTypes = {
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  className: PropTypes.string,
}
